import { customElement, property, query, state } from 'lit/decorators.js';
import { DelegateEvent } from "../../Browser/Objects/metanode";
import { BrowserObject, BFactory } from '../../Browser/Objects/SElement';
import { html } from 'lit';

// import { MNField } from "./field";
// export class MNField extends MetaNode<MNField> {
//     public payloadTarget?: HTMLElement;
//     public captionCell?: HTMLElement;
//     public descriptionTag?: HTMLElement;
//     public payloadFrame?: HTMLElement;
//     public onCaptionChange = new DelegateEvent<string>();
// }

@customElement('lorbiz-field')
export class LorbizField extends BrowserObject<any> {
    @property({ type: Object }) a: any;

    @query('.-pl') payloadFrame!: HTMLDivElement;
    @query('.-cp') captionCell!: HTMLDivElement;    
    @query('.-dd') descriptionTag!: HTMLDivElement;

    @state() public caption: string = '';

    public onCaptionChange = new DelegateEvent<string>();
    setCaption(caption: string) {
        this.caption = caption;
        this.onCaptionChange.invoke(caption);
    }


    override firstUpdated(): void {
      this.setCaption(this.a.c);
    }

    override render() {
        this.a = this.initialArguments;
        this.caption = this.a.c || '{UNSET}';

        const c2: Record<string, any> = {
            '--fullwidth': this.a.w,
            '--payloadonly': this.a.p,
            '--inrow': this.a.r,
            '--nocaption': this.a.hc,
            'double': this.a.d,
        };
        this.classList.add(...Object.keys(c2).filter(key => c2[key]));

        if (this.a.p) {
            return html`
        <div class="-plt"><slot /></div>
    `;
        } else {
            return html`
        <div class="-pl">
          <div class="-cp">${this.caption}</div>
          <div class="-plt"><slot /></div>
          ${this.a.ds ? html`
            <div class="-dd -dsc">${this.a.ds}</div>
          ` : null}
        </div>
    `;
        }
    }


}





export var thisclass = {
    onload: function () { },
    fieldbuilder: function (arg) {
        var builder = window.ood(arg.id, window.document.createElement("div"));
        //builder.className = "fieldbuilder";
        if (arg.isdouble) builder.classList.add("dbl");
        if (arg.iscontainer === true) builder.setAttribute("shcontainer", "");

        builder.moveCell = builder.appendChild(document.createElement("div"));
        //builder.moveCell.className = "builderTool d0 icon-move ui-sort-handle";
        builder.moveCell.classList.add("ui-sort-handle");
        builder.moveCell.classList.add("-mv");
        builder.captionCell = builder.appendChild(document.createElement("div"));
        builder.captionCell.className = "-cp";

        builder.toolCell = builder.appendChild(document.createElement("div"));
        builder.toolCell.className = "-d2";

        builder.wrenchicon = builder.toolCell.appendChild(document.createElement("div"));
        builder.wrenchicon.className = "-edt";
        builder.wrenchicon.onclick = function () { window.jsE(arg.id, "config"); };

        builder.captionTag = builder.toolCell.appendChild(document.createElement("div"));
        if (arg.payloadonly) builder.captionTag.style.display = "none";
        builder.captionTag.innerHTML = arg.toolName;
        builder.captionTag.className = "-caption";

        //builder.style.width = (arg.qw * 55) + "px";

        if (arg.extended) {
            var holder = builder.toolCell.appendChild(document.createElement("div"));
            holder.className = "-pld-holder";
        } else {
            builder.payloadTarget = builder.toolCell.appendChild(document.createElement("div"));
            builder.payloadTarget.className = "-pld";
            //if (arg.payloadonly) builder.payloadTarget.setAttribute("style", "width: calc(100% - 34px); margin-left: 4px;");
            if (arg.payloadonly
            )
                builder.payloadTarget.setAttribute("payloadonly",
                    ""); // builder.payloadTarget.setAttribute("style", "width: calc(100% - 34px); margin-left: 4px;");
        }


        if (arg.canrezise) {
            builder.resizeButton = builder.appendChild(document.createElement("div"));
            //builder.resizeButton.className = "builderTool d3 ui-resizable-handle ui-resizable-e icon-plus";
            builder.resizeButton.classList.add("-resizehandle");
            builder.resizeButton.appendChild(window.document.createElement("div"));
            builder.resizeButton.onclick = function () {
                var qsize = 6;
                if (builder.classList.contains("dbl")) {
                    qsize = 6;
                    builder.classList.remove("dbl");
                } else {
                    qsize = 12;
                    builder.classList.add("dbl");
                }


                //builder.style.width = (qsize * 55) + "px";
                jsE(arg.id, "width|" + qsize);
            }

            if (arg.extended) {
                builder.payloadTarget = builder.appendChild(document.createElement("div"));
                builder.payloadTarget.classList.add("-ext-pld");
            }

            /*$(builder)
                .resizable({
                    grid: (55 * 6),
                    handles: "e",
                    resize: function (event, ui) { ui.size.height = ui.originalSize.height; },
                    stop: function (e, ui) {
                        var targetWidth = (Math.round(ui.size.width / 55) * 55);
                        builder.style.width = targetWidth + "px";
                        jsE(arg.id, "width|" + targetWidth);
                    }
                });*/
        }


        builder.captionInput = builder.captionCell.appendChild(window.document.createElement("input"));
        builder.captionInput.className = "-inpu";
        builder.captionInput.value = arg.caption;
        builder.captionInput.onkeyup = function () { jsE(arg.id, "caption" + builder.captionInput.value) };

    },
    builderCaption: function (id, txt) {
        window.oos(id).captionInput.value = txt;
    },

    //FIELD RESIZING FOR MONO-COLUMN
    resizeWeakMap: new WeakMap(),
    containerResizeObserver: new window.ResizeObserver(entries => {
        entries.forEach(entry => {
            var fieldContainer = entry.target;

            var monoColumn = false;
            if (fieldContainer.clientWidth > 647) monoColumn = false;
            else monoColumn = true;

            if (monoColumn && fieldContainer.isMonoColumn) return null;
            if (!monoColumn && !fieldContainer.isMonoColumn) return null;
            fieldContainer.isMonoColumn = monoColumn;
            var weakSet = thisclass.resizeWeakMap.get(fieldContainer);
            Array.from(fieldContainer.children).filter((x) => weakSet.has(x)).forEach((candidate) => {
                if (monoColumn) candidate.classList.add("mono-column");
                else candidate.classList.remove("mono-column");
            });
            return null;
        });
    }),

    fieldAppendEventHandler: function (ev) {
        if (!ev.target.parentElement.classList.contains("monocolumnresize")
        ) return null; // parent doesn't resize on monocolumn.
        var newField = ev.target;
        var fieldContainer = ev.target.parentElement;
        var weakMap = thisclass.resizeWeakMap;
        if (!weakMap.has(fieldContainer)) weakMap.set(fieldContainer, new window.WeakSet());
        var containerWeakSet = weakMap.get(fieldContainer);
        containerWeakSet.add(newField);
        thisclass.containerResizeObserver.observe(fieldContainer);
        //debugger;

    },

    field: function (a: {
        id: number;
        w?: boolean;
        p?: boolean;
        r?: boolean;
        hc?: boolean;
        d?: boolean;
        c: string;
        ds?: string;
    }) {

        BFactory(LorbizField, a);

    },



    setDescription: function (id, setDescription) {
        var field = window.oos(id);
        if (!field.descriptionTag) return;
        field.descriptionTag.innerHTML = setDescription;
    },

    setPayloadHeight: function (id, height) {
        var field = window.oos(id);
        if (field.payloadFrame) field.payloadFrame.style.height = height + "px";
        if (!field.payloadFrame) field.style.height = height + "px";
    },

    setEnabled: function (id, value) {
        window.setTimeout(function () {
            var field = window.oos(id);
            thisclass.visit(field,
                function (b) {
                    if (b.setAttribute) {
                        if (!value && !b.hasAttribute("disabled")) b.setAttribute("disabled", "");
                        if (value && b.hasAttribute("disabled")) b.removeAttribute("disabled");
                    }
                    return true;
                });
        },
            10);
    },

    visit: function (curElement, func) {
        if (curElement) {
            if (func(curElement) === false) return;
            var children = Array.prototype.slice.call(curElement.children);
            var ownElements = children.filter(x => !x.hasAttribute("id"));
            ownElements.forEach(x => { thisclass.visit(x, func); });
        }
    },


    setValidation: function (id, vtext) {
        var field = oos(id);
        if (field.validation) field.validation.innerHTML = vtext;
        if (field.vlditxt) field.vlditxt.innerHTML = vtext;
    },
    caption: function (id, caption) {
        var fld = window.oos(id);
        fld.captionCell.innerHTML = caption;
        let mtField = MNField.get(fld);
        mtField.onCaptionChange.invoke(caption);
    },

    fieldSetPayload: function (id, content) {
        window.oos(id).payloadTarget.innerHTML = content;
    },
    emptyBox: function (id) {
        var div = window.document.createElement("div");
        div.captionCell = window.document.createElement("span");
        div.payloadTarget = div;
        window.ood(id, div);
    },
    checkbox: function (arg) {
        var field = window.oos(arg.id);
        field.lrinput = field.payloadTarget.appendChild(window.document.createElement("input"));
        field.lrinput.type = "checkbox";
        field.lrinput.checked = arg.v;
        field.serverNotify = true;
        field.lrinput.onchange = function () {
            if (field.serverNotify) window.jsE(arg.id, field.lrinput.checked.toString());
        };
        field.lrinput.setAttribute("style", "position:relative;");

        if (field.descriptionTag) field.descriptionTag.style.display = "none";
        if (arg.d) {
            if (field.captionCell) field.captionCell.innerHTML = "";
            field.lrinput.style.cssFloat = "left";
            field.captionSpan = field.payloadTarget.appendChild(document.createElement("span"));
            field.captionSpan.style.paddingLeft = "7px";
            field.captionSpan.innerHTML = arg.d;
        }

        if (arg.r) {
            field.style.paddingLeft = "8px";
            field.style.marginTop = "4px";
            if (arg.rc === false) if (field.captionSpan) field.captionSpan.style.display = "none";
        }


    },

    setCheckbox: function (id, value) {
        var field = window.oos(id);
        field.serverNotify = false;
        if (field.lrinput.checked !== value) field.lrinput.checked = value;
        field.serverNotify = true;
    },

    setContent: function (id, content) {
        window.oos(id).payloadTarget.innerHTML = content;
    },

    decimal: function (args) {
        var field = window.oos(args.id);
        field.lrinput = field.payloadTarget.appendChild(window.document.createElement("input"));
        field.lrinput.classList.add("-input")
        //field.lrinput.style.paddingRight = "8px";
        field.lrinput.pendsend = false;
        field.lrinput.value = args.value;
        field.lrinput.lastValue = "";
        field.lrinput.onchange = function () {
            if (this.value !== field.lrinput.lastValue) window.jsE(args.id, "change" + field.lrinput.value);
        };
    },


    integer: function (args) {
        var input = window.document.createElement("input");
        input.className = "lorbizfieldinput";
        input.style.textAlign = "right";
        input.style.paddingRight = "8px";

        input.pendsend = false;
        input.value = args.value;

        var field = window.oos(args.id);
        field.lrinput = input;
        field.payloadTarget.appendChild(input);
        input.lastValue = "";
        input.onchange = function () {
            if (this.value !== input.lastValue) {
                input.lastValue = this.value;
                window.jsE(args.id, "change" + input.value);
            }
        };
    },

    annotation: function (a) {
        var field = oos(a.i);
        while (field.firstChild) field.removeChild(field.firstChild);

    },


    decSetValue: function (id, val) {
        var field = oos(id).lrinput;
        field.value = val;
    }
}

